import React from 'react'
import PageTemplate from './PageTemplate'
import Form from './Form'

export default function CreatePokemon() {

    return (

        < >

            <PageTemplate  img={'https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Pokebola-pokeball-png-0.png/769px-Pokebola-pokeball-png-0.png'} content={<Form />}/>

        </ >
    )
}
